import React from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minHeight: 48,
      padding: '0 21px',
      fontSize: 16,
      fontWeight: 400,
      color: theme.palette.grey['500'],
      '&:hover': {
        opacity: 0.9,
      },
      [theme.breakpoints.down('xs')]: {
        minWidth: 100,
        minHeight: 35,
        fontSize: 12,
      },
    },
    label: {
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'flex-start',
        fontSize: 12,
      },
    },
  }),
);

interface Props {
  onClick: any;
}

const LinkButton: React.FC<Props> = ({ onClick, children }) => {
  const classes = useStyles();

  return (
    <Button
      onClick={onClick}
      color="secondary"
      classes={{
        root: classes.root,
        label: classes.label,
      }}
    >
      {children}
    </Button>
  );
};

export default LinkButton;
